module.exports = __webpack_public_path__ + "static/img/coopera.2e00d49.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/coopera.png
// module id = Ix9o
// module chunks = 1